import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app";
import { TransitionTypeRouter } from "@/navigation/components/transition-type-router";
import { watchSystemTheme } from "@/settings/store/use-theme-store";
import "@/styles/app.css";

/**
 * Nothing is refetched on a window focus and nothing polls.
 *
 * This is a management console: what it shows changes when the user changes it,
 * so refetching because they alt-tabbed spends their allowance and Polar's rate
 * limit to redraw the same list.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 60_000 },
  },
});

// Never torn down: this lives as long as the document does, and following the
// machine has to keep working after the choice is made — a machine that turns
// dark at sunset would otherwise leave the page light until it is reloaded.
watchSystemTheme();

const container = document.querySelector("#root");
if (!container) {
  throw new Error("The application root is missing from the document.");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TransitionTypeRouter>
        <App />
      </TransitionTypeRouter>
    </QueryClientProvider>
  </StrictMode>,
);
